import { useState } from 'react';
import { useDealContext } from '@/finsight/application/Deal/DealContext';
import { useTableColumns } from '@/finsight/ui/components/deals/DealListTable/columns/IssueColumns';
import { LoadMore } from '@/finsight/ui/components/deals/DealListTable/components/LoadMore';
import { DealData } from '@/finsight/ui/components/deals/DealListTable/components/DealData';
import { GenericTable, IGenericTableProps } from '@/finsight/ui/components/deals/DealListTable/components/GenericDealListTable';
import { useDealTooltipContext } from '@/finsight/application/Deal/DealTooltipContext';
import { RestrictedAccessRowWrapper } from '@/finsight/ui/components/deals/DealListTable/components/RestrictedAccessRowWrapper';
import { useDealAccess } from '@/finsight/ui/components/deals/useDealAccess';

import styles from '@/finsight/ui/components/deals/DealListTable/table.scss';

export const DealsTable = ({
  showDealDetailsByDefault, ...props
}: Partial<IGenericTableProps<any>> & { showDealDetailsByDefault?: boolean }) => {
  const {
    collection,
    isFetching,
  } = useDealContext();
  const { hasAccess } = useDealAccess();

  const [isRowsExpanded, setIsRowsExpanded] = useState(false);

  const { onClick } = useDealTooltipContext();

  const columns = useTableColumns({ setIsRowsExpanded, isRowsExpanded });

  return (
    <GenericTable
      columns={ columns }
      collection={ collection }
      className={ styles.dealsListTable }
      isRowsExpanded={ isRowsExpanded }
      expandableRowContent={
        (rowData) => (
          <DealData { ...rowData } showDealDetailsByDefault={ showDealDetailsByDefault } />
        )
      }
      isFetching={ isFetching }
      expandableComponent={ <LoadMore /> }
      dataTest="dealsListPanelGroup"
      expandCollapseOnRowClick={ hasAccess }
      RowWrapper={ RestrictedAccessRowWrapper }
      onRowClick={ onClick }
      { ...props }
    />
  );
};
